import { render, staticRenderFns } from "./LeadsNavItem.vue?vue&type=template&id=77182e21"
import script from "./LeadsNavItem.vue?vue&type=script&lang=js"
export * from "./LeadsNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports